<ng-container *ngTemplateOutlet="data.dynamicComponent"></ng-container>
